import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import app from './modules/app';
import auth from './modules/auth';
import plants from './modules/plants';
import { RootState } from './types';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
// const test = process.env.NODE_ENV === 'test';

const storeConfig: StoreOptions<RootState> = {
  strict: debug,
  plugins: [
    createPersistedState({
      paths: ['auth.loginReturnPath', 'auth.user']
    })
  ],
  modules: {
    app,
    auth,
    plants
  }
};

export default new Vuex.Store(storeConfig);
